import { takeEvery } from '@redux-saga/core/effects'; // NOSONAR
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { addTaasLoadingActions } from './addTaasLoadingActions.util';
import { addTaasUpdateAppErrorHandling } from './addTaasUpdateAppErrorHandling';

export function* watchAssekuranztarifChanged() {
  yield takeEvery(GlobalActions.ASSEKURANZTARIF_CHANGED, handleAssekuranztarifChange);
}

export const updateAppActionsGenerator = (appPayload: boolean) => {
  return [new GlobalActions().updateAssekuranztarifData(appPayload)];
};

export const handleAssekuranztarifChange = addTaasLoadingActions(
  addTaasUpdateAppErrorHandling(updateAppActionsGenerator),
);
